import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import QuotePage from './pages/QuotePage';
import WhyChooseUsPage from './pages/WhyChooseUsPage';
import ProcessPage from './pages/ProcessPage';
import AdvicePage from './pages/AdvicePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ArticlePage from './pages/ArticlePage';
import WebDesignPage from './pages/services/WebDesignPage';
import FullStackPage from './pages/services/FullStackPage';
import MaintenancePage from './pages/services/MaintenancePage';
import TechnicalSEOPage from './pages/services/TechnicalSEOPage';
import EcommercePage from './pages/services/EcommercePage';
import WebApplicationsPage from './pages/services/WebApplicationsPage';
import ScrollToTop from './components/utils/ScrollToTop';
import CookieConsent from './components/ui/CookieConsent';

function App() {
  return (
    <>
      <ScrollToTop />
      <Layout>
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/web-design" element={<WebDesignPage />} />
            <Route path="/services/full-stack-development" element={<FullStackPage />} />
            <Route path="/services/maintenance" element={<MaintenancePage />} />
            <Route path="/services/technical-seo" element={<TechnicalSEOPage />} />
            <Route path="/services/ecommerce" element={<EcommercePage />} />
            <Route path="/services/web-applications" element={<WebApplicationsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/quote" element={<QuotePage />} />
            <Route path="/why-choose-us" element={<WhyChooseUsPage />} />
            <Route path="/our-process" element={<ProcessPage />} />
            <Route path="/advice" element={<AdvicePage />} />
            <Route path="/advice/:slug" element={<ArticlePage />} />
            <Route path="/privacy-policy" element={<PrivacyPage />} />
            <Route path="/terms-conditions" element={<TermsPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </AnimatePresence>
      </Layout>
      <CookieConsent />
    </>
  );
}

export default App;